import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AggWidgetHeaderComponent } from './components/agg-widget-header/agg-widget-header.component';
import { AgGridModule } from 'ag-grid-angular';
import { AngMaterialImportModule } from './modules/ang-material-import/ang-material-import.module';
import { ToolBarComponent } from './components/tool-bar/tool-bar.component';
import { BooleanToggleComponent } from './components/boolean-toggle/boolean-toggle.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmModalComponent } from './dialogs/confirm-dialog/confirm-modal.component';
import { UppercaseDirective } from './directives/uppercase/uppercase.directive';
import { DrDateFormatPipe } from './pipes/dr-date-format.pipe';
import { DrDateTimeFormatPipe } from './pipes/dr-date-time-format.pipe';
import { ClaimTypeSelectComponent } from './components/select/claim-type-select/claim-type-select.component';
import { CountrySelectComponent } from './components/select/country-select/country-select.component';
import { ParticipantTypeSelectComponent } from '@app/shared/components/select/participant-type-select/participant-type-select';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FooterComponent } from './components/footer/footer.component';
import { DateTimePickerComponent } from './components/date-time-picker/date-time-picker.component';
import { OnlyDigitsDirective } from '@app/shared/directives/only-digits/only-digits.directive';
import { TimeInputDirective } from '@app/shared/directives/time/time-input.directive';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { DropzoneDirective } from '@app/shared/components/file-upload/dropzone/dropzone.directive';
import { DropzoneComponent } from './components/file-upload/dropzone/dropzone.component';
import { FileOperationListComponent } from './components/file-upload/file-operation-list/file-operation-list.component';
import { FileThumbnailsListComponent } from './components/file-upload/file-thumbnails-list/file-thumbnails-list.component';
import { ThumbNailComponent } from './components/file-upload/thumb-nail/thumb-nail.component';
import { DynamicCheckboxesComponent } from './components/dynamic-checkboxes/dynamic-checkboxes.component';
import { CurrencyDirective } from './directives/currency/currency.directive';
import { BreadcrumbComponent } from '@app/shared/components/breadcrumb/breadcrumb.component';
import { ActionListComponent } from './components/action-list/action-list.component';
import { FileSelectionListComponent } from './components/file-upload/file-selection-list/file-selection-list.component';
import { RouterModule } from '@angular/router';
import { FileSelectionThumbnailsListComponent } from './components/file-upload/file-selection-thumbnails-list/file-selection-thumbnails-list.component';
import { SelectThumbNailComponent } from './components/file-upload/select-thumb-nail/select-thumb-nail.component';
import { FileSelectComponent } from '@app/shared/components/file-upload/file-select/file-select.component';
import { TextAreaDialogComponent } from '@app/shared/dialogs/text-area-dialog/text-area-dialog.component';
import { AlphabetSearchComponent } from '@app/shared/components/alphabet-search/alphabet-search.component';
import { AddressComponent } from '@app/shared/components/address/address.component';
import { GenderComponent } from '@app/shared/components/gender/gender.component';
import { ContactsComponent } from '@app/shared/components/contacts/contacts.component';
import { SimpleConfirmSnackbarComponent } from '@app/shared/components/snackbar/simple-confirm/simple-confirm-snackbar.component';
import { SimpleErrorSnackbarComponent } from '@app/shared/components/snackbar/simple-error/simple-error-snackbar.component';
import { InfoDialogComponent } from '@app/shared/dialogs/info-dialog/info-dialog.component';
import { BanksComponent } from '@app/shared/components/banks/banks.component';
import { PermissionsDirective } from '@app/shared/directives/permissions.directive';
import { DrCurrencyFormatPipe } from '@app/shared/pipes/dr-currency-format.pipe';
import { ValidityPeriodComponent } from '@app/shared/components/validity-period/validity-period.component';
import { EmailChipsComponent } from '@app/shared/components/email-chips/email-chips.component';
import { EditableCommentsComponent } from '@app/shared/components/editable-comments/editable-comments.component';
import { AllowedPageDirective } from './directives/user-allowed-page.directive';
import { CommentsDialogComponent } from '@app/shared/dialogs/comments-dialog/comments-dialog.component';
import { CalculationRowComponent } from '@app/shared/components/calculation-row/calculation-row.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { SmpCkEditorComponent } from '@app/shared/components/smp-ck-editor/smp-ck-editor.component';
import { DrRemoveHtmlTagsPipe } from '@app/shared/pipes/dr-remove-html-tags.pipe';
import { DragNDropChipsComponent } from '@app/shared/components/drag-n-drop-chips/drag-n-drop-chips.component';
import { SmpPhotoEditorComponent5 } from '@app/shared/components/smp-photo-editor/smp-photo-editor-5.component';
import { PhotoEditorDialogComponent } from './dialogs/photo-editor-dialog/photo-editor-dialog.component';
import { MessageServiceComponent } from './components/message-service/message-service.component';
import { MessageDialogComponent } from './dialogs/message-dialog/message-dialog.component';
import { AggMessageActionComponent } from './components/agg-renderer/agg-message-action.component';
import { SearchChipsComponent } from '@app/shared/components/search-chips/search-chips.component';
import { SearchInputComponent } from "@app/shared/components/search-input/search-input.component";
import { SupportAccessDialogComponent } from '@app/shared/dialogs/support-access-dialog/support-access-dialog.component';
import { UserClientSettingsComponent } from '@app/shared/components/user/user-client-settings/user-client-settings.component';
import { UserAdditionalDataComponent } from '@app/shared/components/user/user-additional-data/user-additional-data.component';
import { UserAddressComponent } from '@app/shared/components/user/user-address/user-address.component';
import { UserPermissionRolesComponent } from '@app/shared/components/user/user-permission-roles/user-permission-roles.component';
import { UserCoreComponent } from '@app/shared/components/user/user-core/user-core.component';
import { DrPasswordComponent } from '@app/shared/components/dr-password/dr-password.component';
import { SimpleInputDialogComponent } from '@app/shared/dialogs/simple-input-dialog/simple-input-dialog.component';
import { CreateNameComponent } from '@app/shared/components/create-name/create-name.component';
import { NewParticipantComponent } from '@app/modules/case/components/new-participant/new-participant.component';
import { User2FASmsComponent } from './components/user/user-2fa/user-2fa-sms.component';
import { User2FATotpComponent } from './components/user/user-2fa/user-2fa-totp.component';
import { AutofocusDirective } from './directives/autofocus.directive';
import { DistributionJobListComponent } from '@app/shared/components/distribution-job-list/distribution-job-list.component';
import { DistributionListComponent } from '@app/shared/components/distribution-list/distribution-list.component';
import { DistributionJobComponent } from '@app/shared/components/distribution-job/distribution-job.component';
import { ClaimsNetDistributionHeaderComponent } from '@app/shared/components/distribution-job/claims-net-header/claims-net-distribution-header.component';
import { EmailDistributionHeaderComponent } from '@app/shared/components/distribution-job/email-header/email-distribution-header.component';
import { InSignDistributionHeaderComponent } from '@app/shared/components/distribution-job/insign-header/insign-distribution-header.component';
import { SelectTemplatesDialogComponent } from '@app/shared/dialogs/select-templates-dialog/select-templates-dialog.component';
import { BannerComponent } from './components/banner/banner.component';
import { DrSafeHtml } from './pipes/dr-safe-html.pipe';
import {
  AddressBookSearchDialogComponent
} from "@app/shared/dialogs/address-book-search-dialog/address-book-search-dialog.component";
import { UserCreateDialogComponent } from './dialogs/user-create-dialog/user-create-dialog.component';
import { SystemIdDialogDialogComponent } from '@app/shared/dialogs/system-id-dialog/system-id-dialog.component';
import { InputTextClipboardComponent } from '@app/shared/components/input-text-clipboard/input-text-clipboard.component';


@NgModule({
  declarations: [

    // Components: *******************************
      
    ActionListComponent,
    AddressComponent,
    AggWidgetHeaderComponent,
    AlphabetSearchComponent,
    BanksComponent,
    BooleanToggleComponent,
    BreadcrumbComponent,
    BannerComponent,
    CalculationRowComponent,
    CheckboxComponent,
    ClaimTypeSelectComponent,
    ConfirmModalComponent,
    ContactsComponent,
    CountrySelectComponent,
    CreateNameComponent,
    DateTimePickerComponent,
    DistributionJobListComponent,
    DragNDropChipsComponent,
    DropzoneComponent,
    DrPasswordComponent,
    DynamicCheckboxesComponent,
    EditableCommentsComponent,
    CommentsDialogComponent,
    EmailChipsComponent,
    FileOperationListComponent,
    FileSelectComponent,
    FileSelectionListComponent,
    FileSelectionThumbnailsListComponent,
    FileThumbnailsListComponent,
    FooterComponent,
    GenderComponent,
    InfoDialogComponent,
    NewParticipantComponent,
    ParticipantTypeSelectComponent,
    SearchChipsComponent,
    SearchInputComponent,
    SimpleConfirmSnackbarComponent,
    SimpleErrorSnackbarComponent,
    SelectThumbNailComponent,
    SmpCkEditorComponent,
    SupportAccessDialogComponent,
    SystemIdDialogDialogComponent,
    TextAreaDialogComponent,
    UserCreateDialogComponent,
    ThumbNailComponent,
    ToolBarComponent,
    UserAdditionalDataComponent,
    UserAddressComponent,
    UserClientSettingsComponent,
    UserCoreComponent,
    UserPermissionRolesComponent,
    User2FASmsComponent,
    User2FATotpComponent,
    ValidityPeriodComponent,
    PhotoEditorDialogComponent,
    SmpPhotoEditorComponent5,
    MessageServiceComponent,
    MessageDialogComponent,
    AggMessageActionComponent,
    SimpleInputDialogComponent,
    DistributionListComponent,
    DistributionJobComponent,
    ClaimsNetDistributionHeaderComponent,
    EmailDistributionHeaderComponent,
    InSignDistributionHeaderComponent,
    SelectTemplatesDialogComponent,
    AddressBookSearchDialogComponent,
    InputTextClipboardComponent,


    // Directives: *******************************

    CurrencyDirective,
    DropzoneDirective,
    OnlyDigitsDirective,
    PermissionsDirective,
    TimeInputDirective,
    UppercaseDirective,
    AllowedPageDirective,
    AutofocusDirective,


    // Pipes: ************************************

    DrCurrencyFormatPipe,
    DrDateFormatPipe,
    DrDateTimeFormatPipe,
    DrRemoveHtmlTagsPipe,
    DrSafeHtml,

  ],
  imports: [
    AgGridModule.withComponents([AggWidgetHeaderComponent, AggMessageActionComponent]),
    AngMaterialImportModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CKEditorModule,
    TranslateModule,
  ],
  exports: [

    // Modules: ************************************

    AngMaterialImportModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CKEditorModule,

    // Components: ********************************

    ActionListComponent,
    AddressComponent,
    AggWidgetHeaderComponent,
    AlphabetSearchComponent,
    BanksComponent,
    BooleanToggleComponent,
    BreadcrumbComponent,
    BannerComponent,
    CalculationRowComponent,
    CheckboxComponent,
    ClaimTypeSelectComponent,
    ConfirmModalComponent,
    ContactsComponent,
    CountrySelectComponent,
    CreateNameComponent,
    DateTimePickerComponent,
    DistributionJobListComponent,
    DragNDropChipsComponent,
    DropzoneComponent,
    DynamicCheckboxesComponent,
    EditableCommentsComponent,
    CommentsDialogComponent,
    DrPasswordComponent,
    EmailChipsComponent,
    FileOperationListComponent,
    FileSelectComponent,
    FileSelectionListComponent,
    FileSelectionThumbnailsListComponent,
    FileThumbnailsListComponent,
    FooterComponent,
    GenderComponent,
    InfoDialogComponent,
    NewParticipantComponent,
    ParticipantTypeSelectComponent,
    SimpleConfirmSnackbarComponent,
    SimpleErrorSnackbarComponent,
    SearchChipsComponent,
    SearchInputComponent,
    SelectThumbNailComponent,
    SmpCkEditorComponent,
    SmpPhotoEditorComponent5,
    TextAreaDialogComponent,
    UserCreateDialogComponent,
    ThumbNailComponent,
    ToolBarComponent,
    ValidityPeriodComponent,
    PhotoEditorDialogComponent,
    MessageServiceComponent,
    MessageDialogComponent,
    AggMessageActionComponent,
    SimpleInputDialogComponent,
    DistributionListComponent,
    DistributionJobComponent,
    ClaimsNetDistributionHeaderComponent,
    EmailDistributionHeaderComponent,
    InSignDistributionHeaderComponent,
    SelectTemplatesDialogComponent,
    AddressBookSearchDialogComponent,

    // Directives: ********************************

    CurrencyDirective,
    DropzoneDirective,
    OnlyDigitsDirective,
    PermissionsDirective,
    TimeInputDirective,
    UppercaseDirective,
    AllowedPageDirective,
    AutofocusDirective,


    // Pipes: *************************************

    DrCurrencyFormatPipe,
    DrDateFormatPipe,
    DrDateTimeFormatPipe,
    DrRemoveHtmlTagsPipe,
    DrSafeHtml,
    UserCoreComponent,
    UserAddressComponent,
    UserAdditionalDataComponent,
    UserPermissionRolesComponent,
    UserClientSettingsComponent,
    User2FASmsComponent,
    User2FATotpComponent

  ]
})

export class SharedModule {
}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
